@if (open()) {
  <div class="bottom-sheet-backdrop"
    [style.opacity]="backdropOpacity()"
    (click)="close()"></div>
  <div class="bottom-sheet panel rounded-top rounded-bottom-0 mb-0"
    role="dialog"
    [attr.aria-label]="title()"
    [class.is-dragging]="dragging()"
    [style.transform]="'translateY(' + dragY() + 'px)'">
    <div class="bottom-sheet-grab"
      (pointerdown)="onGrabDown($event)"
      (pointermove)="onGrabMove($event)"
      (pointerup)="onGrabUp($event)"
      (pointercancel)="onGrabUp($event)">
      <div class="bottom-sheet-handle"></div>
      <div class="bottom-sheet-title">
        @if (title()) {
          <span>{{ title() }}</span>
        }
        <ng-content select="[sheetTitle]"></ng-content>
      </div>
    </div>
    <div class="bottom-sheet-body">
      <ng-content></ng-content>
    </div>
  </div>
}
